module.exports = __webpack_public_path__ + "static/media/three_collecting_waves_header@2x.aa84cba7.png";